module.exports = __webpack_public_path__ + "media/images/pic/bialoleka/hero-individual-20bd3fcbe5e6f42e1a1d3a6ba96640ae.webp";